import React from 'react';
import { RiAlertLine, RiLoader4Line, RiCloseLine } from '@remixicon/react';
import Modal from '@components/ui/Modal';

const STEP_LABELS = {
  1: 'Creating aircraft make/model',
  2: 'Creating aircraft record',
  3: 'Saving aircraft features',
  4: 'Saving aircraft amenities',
  5: 'Uploading images to S3',
  6: 'Updating aircraft with images',
};

/**
 * Retry dialog shown when the save state machine fails at any step.
 * Cancel keeps the wizard drawer open so the broker can re-open the
 * retry from the Save button — matches the spec's "stay open" ask.
 */
const SaveRetryDialog = ({ error, isRunning, onRetry, onCancel }) => {
  const open = !!error;
  const stepLabel = error ? (STEP_LABELS[error.step] || `Step ${error.step}`) : '';
  return (
    <Modal
      isOpen={open}
      onClose={onCancel}
      size="sm"
      title={null}
      headerClassName="!border-0"
      closeOnOutsideClick={false}
    >
      <div className="p-6 -mt-6">
        <div className="flex items-start gap-3 mb-4">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
            <RiAlertLine className="w-5 h-5 text-red-600" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-semibold text-gray-900">Save failed at: {stepLabel}</h3>
            <p className="mt-1 text-sm text-gray-600 break-words">{error?.message || 'Unknown error.'}</p>
          </div>
        </div>

        <p className="text-xs text-gray-500 mb-4">
          Retry picks up from the failed step — previously-completed steps aren't re-run.
        </p>

        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={isRunning}
            className="px-4 py-2 rounded-full border border-gray-200 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50 transition-colors"
          >
            <RiCloseLine className="inline w-4 h-4 mr-1" /> Cancel
          </button>
          <button
            type="button"
            onClick={onRetry}
            disabled={isRunning}
            className="px-4 py-2 rounded-full bg-primary-700 hover:bg-primary-800 disabled:bg-gray-300 text-white text-sm transition-colors"
          >
            {isRunning ? (
              <><RiLoader4Line className="inline w-4 h-4 mr-1 animate-spin" /> Retrying…</>
            ) : (
              'Retry'
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SaveRetryDialog;
